import { useState } from "react";
import { Building2, Check, ChevronsUpDown, ExternalLink } from "lucide-react";
import { useActions, useSession, type Account } from "../../../packages/api/client";
import { Button, Dialog, ErrorNotice } from "../../../packages/ui";
import style from "./shell.module.css";

export function ProfileAvatar({ account }: { account: Account }) {
  const [failed, setFailed] = useState(false);
  return <span className={style.avatar}>{account.avatar && !failed
    ? <img src={account.avatar} alt={account.name} referrerPolicy="no-referrer" onError={() => setFailed(true)} />
    : account.name.slice(0, 1)}</span>;
}
export function ManagedCompany({ account, collapsed, dirty }: { account: Account; collapsed: boolean; dirty: boolean }) {
  const [open, setOpen] = useState(false);
  const actions = useActions();
  const { login } = useSession();
  const name = account.organizationName || account.schoolName || "当前企业";
  return <>
    <button type="button" className={`${style.brand} ${style.companyBrand}`} aria-label={`当前企业：${name}，查看企业`} aria-haspopup="dialog" onClick={() => setOpen(true)} title={name}>
      <span className={style.logo}><Building2 size={21} /></span>
      {!collapsed && <><span className={style.companyName}><strong>{name}</strong></span><ChevronsUpDown size={14} /></>}
    </button>
    {open && <Dialog title="我的企业" onClose={() => setOpen(false)}>
      <ErrorNotice error={actions.error}/><div className={style.companyList}>
        {(account.organizations || []).map((org: any) => <div key={org.id} aria-current={org.current ? "true" : undefined}>
          <span className={style.companyMark}><Building2 size={19} /></span><strong>{org.name}</strong>
          <span>{org.current ? <><Check size={14} />当前企业</> : <Button disabled={actions.busy} onClick={() => { if (dirty && !confirm("有未保存的修改，仍要切换企业？")) return; actions.run(async () => { const result = await actions.request<{token:string}>("/managed/organizations/switch", {method:"POST",body:JSON.stringify({orgId:org.id})}); login(result.token); setOpen(false); }); }}>切换</Button>}</span>
        </div>)}
      </div>
      <div className="form-footer"><Button onClick={() => setOpen(false)}>关闭</Button><Button onClick={() => {
        if (!dirty || confirm("有未保存的修改，仍要返回 Flow？")) window.location.assign("https://hjoi.com.cn/asymp-flow/");
      }}><ExternalLink size={14} />在 Flow 切换企业</Button></div>
    </Dialog>}
  </>;
}
export function ManagedAccount({ account }: { account: Account }) {
  const org = (account.organizations || []).find((o: any) => o.current);
  const role = org?.role === "owner" ? "企业负责人" : org?.role === "admin" ? "企业管理员" : "企业成员";
  return <div className={`page ${style.profilePage}`}>
    <div className={style.profileHeading}><ProfileAvatar key={account.avatar} account={account} /><div><strong>{account.name}</strong><span>{role}</span></div></div>
    <dl><dt>当前企业</dt><dd>{account.organizationName || account.schoolName}</dd><dt>应用</dt><dd>教学流</dd></dl>
    <Button onClick={() => window.location.assign("https://hjoi.com.cn/asymp-flow/")}>在 Flow 管理账号<ExternalLink size={14} /></Button>
  </div>;
}
